module.exports = __webpack_public_path__ + "static/com_1-60dade456abfe3299287ef8fa6c9adbf.png";